export function ValidForm(data) {
    function validateIranianNationalCode(code) {
        const regex = /^\d{10}$/ // الگوی 10 رقمی

        if (!regex.test(code)) {
            return false // تعداد رقم‌ها صحیح نیست
        }

        const check = parseInt(code[9]) // رقم کنترل
        let sum = 0

        for (let i = 0; i < 9; i++) {
            sum += parseInt(code[i]) * (10 - i)
        }

        const remainder = sum % 11

        if (
            (remainder < 2 && check === remainder) ||
            (remainder >= 2 && check === 11 - remainder)
        ) {
            return true // کد ملی صحیح است
        } else {
            return false // کد ملی نامعتبر است
        }
    }

    function checkNumericString(str) {
        const trimmedStr = str.trim()
        const numericPattern = /^\d+(\s+\d+)*$/
        if (numericPattern.test(trimmedStr)) {
            return trimmedStr.replace(/\s+/g, '')
        } else {
            return str
        }
    }

    const updatedData = data.map((item) => ({
        valueData: item.valueData,
        textData: item.textData,
        reg: item.reg,
        regText: item.regText,
    }))

    // چک کردن اعداد فارسی پایان

    let result = []
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const persianRegex = /^[\u0600-\u06FF\s]+$/
    const checkRegex = (key, value) => {
        switch (key) {
            case 'email':
                if (!regexEmail.test(value.valueData)) {
                    result.push(value.regText)
                }
                break
            case 'persian':
                console.log('persd')
                if (!persianRegex.test(value.valueData)) {
                    result.push(value.regText)
                }
                break
            case 'nationalCode':
                if (!validateIranianNationalCode(value.valueData)) {
                    result.push(value.regText)
                }
                break
            default:
                return null
        }
    }
    updatedData.map((d) => {
        if (
            d.valueData === undefined ||
            d.valueData === '' ||
            d.valueData === null
        ) {
            result.push(d.textData)
        } else {
            console.log(d)
            if (d.reg !== undefined) {
                console.log('persd')
                checkRegex(d.reg, d)
            }
        }
    })
    return result
}
